import createTableStore from "ds/components/Table/store/useTableStore";

import { BLUEPRINTS_COLUMN_CONFIG, BLUEPRINTS_COLUMNS_STORAGE_KEY } from "./constants";

const useBlueprintsTableStore = createTableStore({
  storageKey: BLUEPRINTS_COLUMNS_STORAGE_KEY,
  config: BLUEPRINTS_COLUMN_CONFIG,
});
export default useBlueprintsTableStore;
